import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { UserAuthorFollowSite } from '../model/UserAuthorFollowSite';
import { catchError, map } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { AuthorService } from '../../shared/services/author.service';
import { Author } from '../../shared/models/Author';
import { CustomEncoder } from '../../shared/services/url.service';

@Injectable()
export class AuthorFollowsService {
  private authorFollowApiURL = APP_SETTINGS.AuthorFollowApiUrl;

  constructor(
    private executeService: ExecuteService,
    private authorService: AuthorService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetAuthorFollowsByEmail(email: string): Observable<UserAuthorFollowSite[]> {
    const url: string = this.authorFollowApiURL;
    const params = new HttpParams({ encoder: new CustomEncoder() }).set('email', email);

    return Observable.forkJoin([
      this.authorService.GetAuthors(),
      this.executeService.ExecuteWithToken('get', url, params)])
      .pipe(
        map(([authors, authorFollows]) => {
          return this.mapAuthorFollowModels(authorFollows, authors);
        }),
        catchError(this.errorHandler.handleError<object[]>('AuthorFollowsService_GetAuthorFollowsByEmail email', [], true))
      );
  }

  public Delete(email: string) {
    const url = this.authorFollowApiURL;
    const body = { email: email };

    return this.executeService.ExecuteWithToken('delete', url, null, body)
      .pipe(
        catchError(this.errorHandler.handleAndThrowError('AuthorFollowsService_Delete', null, true))
      );
  }

  mapAuthorFollowModels(authorFollows: any[], authors: Author[]): any {
    let response: UserAuthorFollowSite[] = [];
    if (authorFollows != null) {
      authorFollows.forEach(af => {
        var author = authors.find(a => a.AuthorId === af.authorId);
        if (typeof author !== 'undefined') {
          response.push({
            AuthorFollowId: af.id,
            AuthorId: af.authorId,
            AuthorName: author.Name,
            LanguageId: af.languageId,
            Email: af.email
          });
        }
      });
    }
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/authorFollows.service.ts